const SvgTwitter = () => (
	<svg width="1em" height="1em" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			strokeWidth={2}
			d="M1 21.012c6.593 3.173 20.46 4.878 23.189-13.689.955-.428 2.521-1.608 2.811-4.813-.91.66-2.668.95-4.414.783-2.876-1.529-8.696-2.585-8.968 5.42C10.547 8.296 3.877 6.17 1.75 1 .795 4.752.632 13.354 7.616 17.746c-.307.533-1.446 1.675-3.547 1.98"
		/>
	</svg>
)

export default SvgTwitter
